export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fb2dc0de889c72466cf8781f8459b7ed5b2ee08e7&name=fetchTypeahead!'